export const ACCESS_TOKEN_KEY = 'ATK_STUDENT_QUESTOPHIA';
